export default __webpack_public_path__ + "static/media/reward.7baa9740.gif";